import { sanitizeInput } from '@/utils/security'

export function sanitizeQueryValue(value: string | null | undefined): string {
  return value ? sanitizeInput(value) : ''
}

export function sanitizeQueryValueOrUndefined(value: string | null | undefined): string | undefined {
  return value ? sanitizeInput(value) : undefined
}
